var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFire = function SvgFire(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.468 8.395-.002.001-.003.002zm9.954-.187a1.2 1.2 0 0 0-.23-.175 1 1 0 0 0-1.4.411 5.8 5.8 0 0 1-1.398 1.778 8.71 8.71 0 0 0-4.267-9.092 1 1 0 0 0-1.49.806 7.02 7.02 0 0 1-2.472 4.942l-.23.187a8.5 8.5 0 0 0-1.988 1.863 8.984 8.984 0 0 0 3.656 13.908 1 1 0 0 0 1.327-1.238 7 7 0 0 1-.19-2.581 9 9 0 0 0 4.313 4.016c.225.101.48.115.715.038a8.995 8.995 0 0 0 3.654-14.863m-3.905 12.831a6.97 6.97 0 0 1-3.576-4.402 9 9 0 0 1-.18-.964 1 1 0 0 0-1.858-.362 8.96 8.96 0 0 0-1.205 4.717 6.986 6.986 0 0 1-1.176-9.868 6.6 6.6 0 0 1 1.562-1.458 1 1 0 0 0 .075-.054s.296-.246.307-.252a8.97 8.97 0 0 0 2.898-4.632 6.736 6.736 0 0 1 1.386 8.088 1.001 1.001 0 0 0 1.184 1.418 7.86 7.86 0 0 0 3.862-2.688 7.002 7.002 0 0 1-3.279 10.457"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFire);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/fire.f47d94989d3d50a1bc5a7880a8e8b7be.svg";